module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-4c612d8c1db370e0238f47769f225a01.webp";